import { useEffect, useState } from 'react';

import { usePostHog } from 'posthog-js/react';

export const useFeatureFlagsLoaded = () => {
  const posthog = usePostHog();
  const [loaded, setLoaded] = useState(() => posthog.featureFlags.hasLoadedFlags);

  useEffect(() => {
    if (loaded) return;
    posthog.onFeatureFlags(() =>{  setLoaded(true); });
  }, [posthog, loaded]);

  return loaded;
};
